import { Config } from "final-form"
import Component from "vue-class-component"

import { Location } from "@skinsoft/types"
import { ReactiveVue } from "@skinsoft/reactive-vue"
import { LocationSelectorPopup } from "@skinsoft/entity-ui/src/location/location-selector-popup"
import { Field, Form, LocalizedString, ThesaurusTermChooser } from "@skinsoft/ui"

@Component({
    components: {
        sLocationSelectorPopup: LocationSelectorPopup,
        sLocalizedString: LocalizedString,
        sThesaurusTermChooser: ThesaurusTermChooser,
    },
    props: ['onSubmit', 'initialValues', 'motives'],
    template: require('./create-container-form.html')
})
export class CreateContainerForm extends ReactiveVue {
    public onSubmit: Config['onSubmit'];

    private location: Location = null as any

    public $refs: {
        locationPopup: LocationSelectorPopup
        location: Field
        form: Form
    }

    private onLocationSelected(locationEvent) {
        this.location = locationEvent.location
        this.$refs.location.$emit('change')
        const form = this.$refs.form.form;
        form.change('location', locationEvent.location)
        form.change('locationName', this.formatLocationInField(locationEvent.location))
        form.mutators.setFieldTouched('locationName', true)

    }

    private openPopup() {
        this.$refs.locationPopup.open()
    }

    private formatLocationInField(location) {
        return location.genericEntityTitle.translatedString[this.getAppLocale()]
    }
}